import ContactDetailService from "@/services/profile/ContactDetailService";
import _ from 'lodash';

const state = {
};

const getters = {

};

const mutations = {

};

const actions = {

	store({commit}, payload) {
		return new Promise((resolve, reject) => {
			ContactDetailService.store(payload)
				.then((resp) => {
					if (resp.data.success) {
						commit('PROFILE_CLIENT_STORE/UPDATE_VALUE_SET', {
							name: 'contacts',
							value: resp.data.data
						}, {root: true});
					}
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	update({commit}, {id, payload}) {
		return new Promise((resolve, reject) => {
			ContactDetailService.update(id, payload)
				.then((resp) => {
					if (resp.data.success) {
						commit('PROFILE_CLIENT_STORE/UPDATE_VALUE_SET', {
							name: 'contacts',
							value: resp.data.data
						}, {root: true});
					}
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	setAsDefault({commit, rootGetters}, id) {
		return new Promise((resolve, reject) => {
			let payload = _.cloneDeep(rootGetters['PROFILE_CLIENT_STORE/CLIENT'].contacts.find(i => i.id === id))
			payload.primary = true;

			ContactDetailService.update(id, payload)
				.then((resp) => {
					if (resp.data.success) {
						commit('PROFILE_CLIENT_STORE/UPDATE_VALUE_SET', {
							name: 'contacts',
							value: resp.data.data
						}, {root: true});
					}
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

	destroy({commit}, id) {
		return new Promise((resolve, reject) => {
			ContactDetailService.delete(id)
				.then((resp) => {
					if (resp.data.success) {
						commit('PROFILE_CLIENT_STORE/UPDATE_VALUE_SET', {
							name: 'contacts',
							value: resp.data.data
						}, {root: true});
					}
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	},

};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
